import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import React from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useUrlSearchParams } from "use-url-search-params";
// import image from "../../../assets/izumrud/sidebar-bg.jpg";
import UserInfo from "../../../components/UserInfo";
import menuItems from "../../../pages/main/menuItems";
import { useAuthDatas } from "../../../auth/JWTAuthProvider";
import translate from "../../../i18n/translate";

export default function Sidebar({ collapsed }) {
  const location = useLocation();
  const [{ pageId }] = useUrlSearchParams();
  const { user } = useAuthDatas();
  const pathList = location.pathname.split("/");
  const activeMenu = [
    pageId,
    pathList[pathList.length - 1],
    pathList[pathList.length - 2],
  ];
  const navigate = useNavigate();

  const getMenuItem = (item) => {
    switch (item.type) {
      case "group":
        return (
          <>
            <p
              style={{
                padding: "8px 24px",
                fontWeight: "600",
                fontSize: 14,
                color: "#6b7280",
              }}
            >
              {item.name}
            </p>
            {getMenuItems(item.children)}
          </>
        );

      case "collapse":
        return (
          <Menu.SubMenu
            key={item.key}
            title={item.messageId}
            icon={item.icon}
            onTitleClick={() => item.link && navigate(item.link)}
          >
            {getMenuItems(item.children)}
          </Menu.SubMenu>
        );

      default:
        break;
    }
    return (
      <Menu.Item key={item.key} icon={item.icon}>
        <Link to={item.link}>{translate(item.messageId)}</Link>
      </Menu.Item>
    );
  };

  const getMenuItems = (items) => {
    return items
      .filter((item) => !item.roles || item.roles.includes(user.role))
      .map(getMenuItem);
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={50}
      theme="light"
      style={{
        overflowY: "auto",
        overflowX: "hidden",
        height: "100vh",
        backgroundSize: "auto 130%",
        backgroundPosition: "20% 0%",
      }}
    >
      <UserInfo></UserInfo>
      <br />
      <Menu theme="light" mode="inline" selectedKeys={activeMenu} defaultOpenKeys={["user1"]}>
        {getMenuItems(menuItems)}
      </Menu>
    </Sider>
  );
}
